import { PAGE_BUILDER_DOMAINS, HS_SITES_DOMAINS } from 'payments-checkout-lib/constants/domains';
import { getIframeLayout } from './queryParams';
import { fetchHcmsDataForCustomDomain } from 'payments-checkout-lib/data/hcmsApi';
import { getFullUrl } from 'hubspot-url-utils';
import enviro from 'enviro';
import { getIsCustomDomain } from 'payments-checkout-lib/utils/urls';
import { setWindowLocationHref } from 'hs-browser-apis/location';
export const getInternalDomainConfig = hostname => {
  const parts = hostname.split('.');
  if (parts.length < 2) {
    return null;
  }

  // Direct O(1) lookup with last 2 parts for page builder and hs-sites domains
  const baseDomain = parts.slice(parts.length - 2).join('.');
  return PAGE_BUILDER_DOMAINS[baseDomain] || HS_SITES_DOMAINS[baseDomain] || null;
};
export const getHubletAndEnvOverrides = async hostname => {
  const internalDomainConfig = getInternalDomainConfig(hostname);
  const isCustomDomain = getIsCustomDomain(hostname);
  if (internalDomainConfig) {
    return internalDomainConfig;
  } else if (isCustomDomain) {
    const hcmsConfig = await fetchHcmsDataForCustomDomain();
    return hcmsConfig;
  }
  return {
    hublet: undefined,
    env: undefined
  };
};
export const redirectToUrl = url => {
  const iFrameLayout = getIframeLayout();
  if (iFrameLayout) {
    // @ts-ignore ts-migrate(2531) FIXME: Object is possibly 'null'.
    window.top.location.href = url;
  } else {
    setWindowLocationHref(url);
  }
};
export const redirectToUrlAsync = (url, delay = 1500) => {
  // setTimeout is used in order to wait for UILoadingButton animation to
  // complete to indicate a successful transaction to the buyer before redirect
  return setTimeout(() => redirectToUrl(url), delay);
};
export const appendEmailToUrlIfEnabled = (url, email, includeEmailInSuccessRedirect) => {
  if (!includeEmailInSuccessRedirect || !email) {
    return url;
  }
  try {
    const urlObj = new URL(url);
    urlObj.searchParams.set('email', email);
    return urlObj.toString();
  } catch (error) {
    console.warn('Failed to append email to URL:', error);
    return url;
  }
};
export const appendPaymentMethodToUrl = (url, paymentMethod) => {
  if (!paymentMethod) {
    return url;
  }
  try {
    const urlObj = new URL(url);
    urlObj.searchParams.set('paymentMethod', paymentMethod.toLowerCase());
    return urlObj.toString();
  } catch (error) {
    console.warn('Failed to append paymentMethod to URL:', error);
    return url;
  }
};
export const getIsPaymentPurchaseUrl = pathname => {
  return pathname.includes('/purchase/');
};
export const getIsIframePreviewUrl = pathname => {
  return pathname.includes('/iframe/preview');
};
export const getIsIframePreviewTestUrl = pathname => pathname.includes('/iframe/preview/test');
export const getIsIframeableUrl = pathname => {
  return pathname.includes('/iframe/');
};

// Preview messages contain the entire checkout session, so only HubSpot's app
// origin may initialize that route. Other iframe routes load their checkout
// session from the server and remain embeddable by public and custom domains.
export const getAllowedParentOrigins = (pathname = window.location.pathname) => {
  if (!enviro.deployed() || !getIsIframePreviewUrl(pathname)) {
    return undefined;
  }
  return [new URL(getFullUrl('app')).origin];
};